import { getLocalDayKey } from '../utils/dailyRuntime.js'
import { calculateNextExecutionTime } from '../utils/scheduledJobsHelper.js'

export function prepareScheduledRecovery(jobs, now = new Date(), { catchUp = true } = {}) {
  const dueJobs = []
  const scheduledJobs = Object.fromEntries(Object.entries(jobs || {}).map(([id, job]) => {
    if (!job || !['scheduled', 'executing'].includes(job.status)) return [id, job]
    const due = new Date(job.scheduledTime)
    if (due > now) return [id, job.status === 'executing' ? { ...job, status: 'scheduled' } : job]
    if (catchUp && getLocalDayKey(due) === getLocalDayKey(now)) dueJobs.push(job)
    return [id, { ...job, status: 'scheduled',
      scheduledTime: calculateNextExecutionTime(job.originalScheduleTime || '09:00', now).toISOString() }]
  }))
  return { scheduledJobs, dueJobs }
}

export function queueRecoveredSchedules(manager, jobs, now = Date.now()) {
  const covered = new Set(manager.recoveredPairs || [])
  for (const item of manager.taskQueue) {
    for (const pair of manager.getPendingPairs(item)) covered.add(`${pair.taskId}:${pair.accountKey}`)
  }
  for (const job of jobs) {
    for (const accountKey of job.accounts) {
      const tasks = job.tasks.filter(taskId => !covered.has(`${taskId}:${accountKey}`))
      for (const taskId of tasks) covered.add(`${taskId}:${accountKey}`)
      if (tasks.length) manager.addBatchToQueue({ ...job, tasks, accounts: [accountKey],
        executionId: `recovery_${job.id}_${accountKey}_${now}`, scheduledJobId: job.id, source: 'scheduled' })
    }
  }
  manager.recoveredPairs = null
}
